import { Phone, ArrowRight } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../lib/constants";

export const CallButton = ({ className = "", label, testId = "call-btn" }) => (
  <a
    href={PHONE_TEL}
    data-testid={testId}
    className={`inline-flex items-center justify-center gap-3 bg-brand text-black font-bold uppercase tracking-wider text-sm sm:text-base px-7 py-4 btn-brutalist ${className}`}
  >
    <Phone className="h-4 w-4" strokeWidth={2.75} />
    {label || `Call ${PHONE_DISPLAY}`}
  </a>
);

export const QuoteButton = ({
  className = "",
  label = "Get a Fast Quote",
  testId = "quote-btn",
}) => (
  <a
    href={PHONE_TEL}
    data-testid={testId}
    className={`inline-flex items-center justify-center gap-3 bg-transparent border-2 border-white text-white font-bold uppercase tracking-wider text-sm sm:text-base px-7 py-4 hover:bg-white hover:text-black transition-colors ${className}`}
  >
    {label}
    <ArrowRight className="h-4 w-4" strokeWidth={2.75} />
  </a>
);

export const SectionLabel = ({ children, className = "" }) => (
  <div
    className={`inline-flex items-center gap-3 text-xs uppercase tracking-[0.28em] text-brand font-bold ${className}`}
  >
    <span className="h-[2px] w-8 bg-brand" />
    {children}
  </div>
);
